<script>
  import Modal from "../../Components/Modal.svelte";
  import { page } from "@inertiajs/svelte";

  export let showHelpRIN;
</script>

<Modal
  bind:open={showHelpRIN}
  dialogClasses="modal-dialog-centered text-center"
>
  <div class="modal-header">
    <h3 class="mb-0">Locating your RIN</h3>
    <button
      type="button"
      class="btn-close float-end"
      on:click={() => (showHelpRIN = false)}
    ></button>
  </div>
  <div class="modal-body">
    <p>
      Your Renewal ID Number can be found on your Renewal Notice, as seen below.
    </p>
    <img
      src={`${import.meta.env.VITE_ASSET_URL}/images/new-form-zoomed.png`}
      alt=""
    />
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" on:click={() => (showHelpRIN = false)}
      >Close</button
    >
  </div>
</Modal>
